import { Injectable } from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient, HttpHeaders} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  baseUrl = environment.apiRecord;
  constructor(private http: HttpClient) { }

  login(loginData: any): Promise<any>{
    const httpOptions = {
      headers: new HttpHeaders({'Content-Type': 'application/json'})
    };
    return  this.http.post( `${this.baseUrl}/api/v1/login`, loginData, httpOptions).toPromise();
  }
}
